import { ThemeType } from "./temas/temas-config-ts";

/* =========================
   ESTRUTURAS DE RESPOSTA API
========================= */
export interface GestaoResponse<T = any> {
  codeResponse: string;
  title: string;
  message: string;
  dataResponse: T;
}

/* =========================
   ENUMS
========================= */
export enum AgendamentoStatus {
  AGUARDANDO = "Aguardando",
  CONFIRMADO_EMPRESA = "Confirmado pela empresa",
  CONFIRMADO_AUTOMATICO = "Confirmado Automaticamente",
  CANCELADO_EMPRESA = "Cancelado pela Empresa",
  CANCELADO_CLIENTE = "Cancelado pelo cliente",
  EXECUTADA = "Executada",
}

export enum AgendamentoStep {
  SERVICOS = 1,
  HORARIOS = 2,
  PROFISSIONAIS = 3,
  RESUMO = 4,
  CONFIRMACAO = 5,
  CONSULTA = 6,
}

/* =========================
   MODELOS DTO
========================= */

export interface UnidadeDto {
  nomeFantasia: string;
  razaoSocial: string;
  telefoneFormatado: string;
  codigo: number;
  nome: string;
  logomarca?: string;
  enderecoCompleto?: string;
  tema?: ThemeType; // Campo opcional para definir o tema na unidade
}

export interface ServicoDto {
  codigo: number;
  descricao: string;
  informacao: string;
  foto: string;
  valor: number;
  tempoExecucao: number;
}

export interface CategoriaDto {
  codigo: number;
  nome: string;
  descricao: string;
  produtos: ServicoDto[];
}

/**
 * ProfissionalDto reflete o retorno do back-end Java.
 * O TreeMap<LocalDate, List<LocalTime>> do Java é convertido
 * para um Objeto Javascript onde a chave é string (data) e o valor é array de strings (horas).
 */
export interface ProfissionalDto {
  codigo: number;
  nome: string;
  apelido?: string;
  apresentacao: string;
  foto?: string;
  valor: number; // Valor adicional/base do profissional
  tempoExecucao?: string;
  // Representação do TreeMap<LocalDate, List<LocalTime>>
  diaHorarios: Record<string, string[]>; 
}

export interface PrecoProfissionalDto {
  codigoProfissional: number;
  valor: number;
}

/* =========================
   ESTADO GLOBAL (STORE)
========================= */

export interface AgendamentoState {
  step: AgendamentoStep;
  unidade?: UnidadeDto;
  servico?: ServicoDto;
  data?: string;   // Data selecionada (ex: "2026-02-19")
  horario?: string; // Horário selecionado (ex: "09:00")
  profissional?: ProfissionalDto;
  
  // Cache para evitar requisições repetidas ao back-end
  profissionaisDisponiveis: ProfissionalDto[]; 
  
  tema?: ThemeType;
}

export interface ProfissionalHorarioDto {
  codigo: number;
  nome: string;
  apelido: string;
  foto: string;
  valor: number; // Valor adicional deste profissional (se houver)
  apresentacao: string;
  tempoExecucao: string;
  /**
   * Mapeia o TreeMap<LocalDate, List<LocalTime>> do Java.
   * A chave (string) é a data formatada ISO (YYYY-MM-DD).
   * O valor (string[]) são os horários (HH:mm).
   */
  diaHorarios: Record<string, string[]>;
}

export interface ResumoEnvioDto {
  nome: string;
  celular: string;
  data: string;
  horario: string;
  executante: { codigo: number }; // Corresponde ao Executante do Java
  unidade: { codigo: number };    // Corresponde à UnidadeAtendimento do Java
  produto: { codigo: number };    // Corresponde ao Produto do Java
}